import {
  ContentTypeFieldResponse,
  CpsDocumentMetadataValue,
  CPS_CONTENT_TYPE_FIELD_TYPE
} from '@cs-cms/types';

const toMultiChoiceFormValue = (rawValue: unknown): string[] => {
  if (Array.isArray(rawValue)) {
    return rawValue.map(item => String(item));
  }

  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return [];
  }

  if (typeof rawValue === 'string') {
    try {
      const parsed: unknown = JSON.parse(rawValue);
      if (Array.isArray(parsed)) {
        return parsed.map(item => String(item));
      }
      if (parsed !== null && parsed !== undefined && parsed !== '') {
        return [String(parsed)];
      }
      return [];
    } catch {
      return [rawValue];
    }
  }

  return [String(rawValue)];
};

export const toFormFieldValue = (
  field: ContentTypeFieldResponse,
  rawValue: unknown
): CpsDocumentMetadataValue => {
  if (field.type === CPS_CONTENT_TYPE_FIELD_TYPE.MULTI_CHOICE) {
    return toMultiChoiceFormValue(rawValue);
  }

  if (rawValue === null) {
    return undefined;
  }

  if (
    typeof rawValue === 'string' ||
    typeof rawValue === 'number' ||
    typeof rawValue === 'boolean' ||
    rawValue instanceof Date ||
    rawValue === undefined
  ) {
    return rawValue;
  }

  return undefined;
};
